module.exports = __webpack_public_path__ + "90d3a536904e154c0ccfe61bef5d6c18.svg";


//////////////////
// WEBPACK FOOTER
// ./app/components/PageListHeader/images/logo-typography-academy.svg
// module id = 877
// module chunks = 9